import { TwinDictionary } from '../../../../../../utils/globals/dictionary'

export const getOptionsFromExtraDataSellVariable = (extraData: string) => {
    let result: string[] = []
    const parsedExtraData = JSON.parse(extraData || '{}')
    if (Object.keys(parsedExtraData)?.length > 0) {
        for (const key in parsedExtraData) {
            const value = parsedExtraData[key]
            result.push(value.name)
        }
    }
    return result
}

export const parseOptionsSellVariable = (options: string[]) => {
    const result: TwinDictionary = {}
    for (const key in options) {
        result[key] = { value: key, name: options[key] }
    }
    return result
}